import { FC } from 'react';
// 组件
import { MenuOutlined, DeleteOutlined, } from '@ant-design/icons';
import CardFormItem from '../cardFormItem';
// 方法
import { useSortable } from '@dnd-kit/sortable';
// 常量
import { CSS } from '@dnd-kit/utilities';
import { CARD_FORM_NAME, CardGroupProps } from '../../interface';
import { STATUS_CREATED, STATUS_CREATED_CODE } from '../../../constants/constant';

/** card表单可拖拽组 */
const CardDidGroup: FC<CardGroupProps> = props => {
  const { form, formItems, value, groupKey, isDelete, disabled, onChange, onDelete, formatChangeValue, } = props;
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
  } = useSortable({
    id: groupKey,
  });
  /** 卡片组值修改回调 */
  const handleChange = (name: string, itemValue: any, associationNames?: string[], options?: any) => {
    const changeGroupValue: any = {
      ...value,
      ...(formatChangeValue ? formatChangeValue(name, itemValue, options) : undefined),
      [STATUS_CREATED_CODE]: value[STATUS_CREATED_CODE] !== STATUS_CREATED.ADD ? STATUS_CREATED.UPDATE : value[STATUS_CREATED_CODE],
    };
    const formData = form.getFieldValue([CARD_FORM_NAME, groupKey]);
    const newGroupValue: any = {...changeGroupValue, ...formData};
    if (Array.isArray(associationNames) && associationNames.length) {
      associationNames.forEach(item => {
        form.setFieldValue([CARD_FORM_NAME, groupKey, item], undefined);
      });
    }
    formItems?.filter(item => {
      const { hide } = item;
      if (hide === undefined) return false;
      if (typeof hide === 'function') {
        return hide(newGroupValue);
      }
      return hide;
    }).map(item => {
      const { name, labelKey } = item;
      form.setFieldValue([CARD_FORM_NAME, groupKey, name], undefined);
      if (!!labelKey) {
        changeGroupValue[labelKey] = undefined;
      }
    });
    onChange?.(groupKey, changeGroupValue, name, itemValue);
  };
  /** 点击删除 */
  const handleDelete = () => {
    onDelete?.([groupKey]);
  };
  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div className='form-card-group' ref={setNodeRef} style={style} {...attributes}>
      {
        !disabled && (
          <div className='form-card-group-operation'>
            <MenuOutlined
              className='form-card-group-operation-move'
              ref={setActivatorNodeRef}
              style={{ touchAction: 'none', cursor: 'move' }}
              {...listeners}
            />
            {
              isDelete && (
                <DeleteOutlined
                  className='form-card-group-operation-delete'
                  onClick={handleDelete}
                />
              )
            }
          </div>
        )
      }
      <div className='form-card-group-body'>
        {
          formItems?.map((item, index) => {
            return (
              <CardFormItem
                form={form}
                key={item.name || index}
                groupKey={groupKey}
                groupValue={value}
                disabled={disabled || item.disabled}
                {...item}
                initialValue={value?.[item.name] === undefined ? item.initialValue : value?.[item.name]}
                onChange={handleChange}
              />
            );
          })
        }
      </div>
    </div>
  );
};

export default CardDidGroup;